import React, { useEffect, useState } from 'react';

const STORAGE_KEY = 'site_cookie_consent_v1';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const val = localStorage.getItem(STORAGE_KEY);
      if (!val) setVisible(true);
    } catch (e) {
      // localStorage might be blocked — show banner for safety
      setVisible(true);
    }
  }, []);

  function accept() {
    try { localStorage.setItem(STORAGE_KEY, 'accepted'); } catch(e) {}
    setVisible(false);
    // enable analytics/cookies here if necessary
  }

  function decline() {
    try { localStorage.setItem(STORAGE_KEY, 'declined'); } catch(e) {}
    setVisible(false);
    // disable analytics/cookies here if necessary
  }

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      style={{
        position: 'fixed',
        right: 24,
        left: 24,
        bottom: 24,
        zIndex: 9999,
        background: '#fff',
        borderRadius: 10,
        boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
        padding: 16,
        display: 'flex',
        gap: 12,
        alignItems: 'center',
        fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial',
      }}
    >
      <div style={{ flex: 1, fontSize: 14, color: '#222' }}>
        This website uses cookies to enhance your browsing experience and analyse traffic. By using our site, you agree to our cookie policy.
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        <button
          onClick={decline}
          style={{
            padding: '8px 12px',
            borderRadius: 6,
            fontWeight: 600,
            border: '1px solid #0f7a5a',
            background: 'transparent',
            color: '#0f7a5a',
            cursor: 'pointer'
          }}
        >
          Decline
        </button>

        <button
          onClick={accept}
          style={{
            padding: '8px 12px',
            borderRadius: 6,
            fontWeight: 700,
            border: 'none',
            background: '#0f7a5a',
            color: '#fff',
            cursor: 'pointer'
          }}
          autoFocus
        >
          Accept
        </button>
      </div>
    </div>
  );
}
